import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
} from '@angular/core';
import { LearningResourceViewModel } from '@app/inputs/models/learning-resource.view-model';
import { NormalizedRecommendation } from '@app/recommendations/recommendations.api';
import { ContentCardService } from '@app/shared/components/content/content-card/content-card.service';
import { ModifyOptionsFnType } from '@app/shared/components/menu/menu.component';
import { UserRecommendationType } from '@app/shared/models/core.enums';
import { EncodeToEntitiesPipe } from '@app/shared/pipes/encode-to-entities.pipe';
import { WindowLayoutService } from '@app/shared/services/window-layout/window-layout.service';
import { ProfileSharedService } from '../profile-shared.service';

/**
 * This component will pick which child component should show based on the recommendation type.
 * This also will append the creator information onto the top of the tile
 */
@Component({
  selector: 'dgx-profile-shared-tile',
  templateUrl: './profile-shared-tile.component.html',
  styleUrls: ['./profile-shared-tile.component.scss'],
})
export class ProfileSharedTileComponent implements OnChanges, OnDestroy {
  @Input() public section: string;
  @Input() public itemIndex: number;
  @Input() public lazyChunkIndex: number;
  @Input() public item: NormalizedRecommendation;
  @Output()
  public dismissOpportunity: EventEmitter<NormalizedRecommendation> = new EventEmitter();
  public modifyOptionsFn: ModifyOptionsFnType<LearningResourceViewModel>;
  public isIframe: boolean = false;
  public userRecHeaderItem: any;

  constructor(
    private encodeToEntitiesPipe: EncodeToEntitiesPipe,
    private profileSharedService: ProfileSharedService,
    private windowLayoutService: WindowLayoutService,
    public contentCardService: ContentCardService
  ) {}

  public ngOnChanges(): void {
    this.modifyOptionsFn = this.profileSharedService.configureModifyOptionsFn(
      this.item
    );
    this.userRecHeaderItem = {
      ...this.item,
      group: this.item.groupId
        ? {
            groupId: this.item.groupId,
            groupName: this.item.groupName,
          }
        : null,
      recommendationType: UserRecommendationType.Recommendation,
      contentType: this.item._displayType,
    };
    this.isIframe = this.windowLayoutService.isIframe;
  }

  public ngOnDestroy(): void {
    this.contentCardService.setIndexesOfExpandedCards([]);
  }

  public onDismiss($event): void {
    this.dismissOpportunity.emit($event);
  }

  public dismiss() {
    this.profileSharedService.dismiss(this.item).subscribe();
  }
}
